/**
 * O que fica por cima da tela, ancorado num botao: o balao do (i) e o menu de acoes da
 * linha.
 *
 * O elemento e um `popover` manual, que o navegador desenha na camada de cima, com
 * posicao fixa calculada pelo botao. Absoluto dentro de uma tabela com rolagem, ele
 * aumentava a area rolavel (a barra horizontal do cabecalho dos Relatorios) ou era
 * cortado pela borda da tabela. Na camada de cima nao muda o tamanho nem a rolagem de
 * nada, e fica tambem por cima de janela modal.
 *
 * Onde o navegador nao tem popover (navegador antigo, ambiente de teste), o atributo
 * ficaria so escondendo o elemento: sem ele, o mesmo elemento aparece com a posicao
 * fixa.
 */
export const temPopover =
  typeof HTMLElement !== 'undefined' &&
  typeof HTMLElement.prototype.showPopover === 'function';

/** Distancia minima ate a borda da janela, e do elemento ate o botao. */
const MARGEM_DA_JANELA = 8;
const DISTANCIA_DO_BOTAO = 4;

/** Sobe o elemento para a camada de cima, quando o navegador tem popover. */
export function abrirNaCamadaDeCima(elemento: HTMLElement): void {
  if (!temPopover) return;
  try {
    elemento.showPopover();
  } catch {
    // Ja aberto, ou fora do documento: a posicao fixa basta.
  }
}

/**
 * Posiciona o elemento junto da ancora, dentro da janela: abaixo dela; acima, quando
 * nao cabe embaixo. Alinhado pelo inicio da ancora (o balao do rotulo) ou pelo fim (o
 * menu da coluna de acoes, que fica na borda direita da tabela); puxado para dentro
 * quando passaria da borda da janela.
 */
export function posicionarJunto(
  elemento: HTMLElement,
  ancora: HTMLElement,
  alinhamento: 'inicio' | 'fim' = 'inicio',
): void {
  const caixa = ancora.getBoundingClientRect();
  const largura = elemento.offsetWidth;
  const altura = elemento.offsetHeight;
  const janelaLargura = document.documentElement.clientWidth || window.innerWidth;
  const janelaAltura = document.documentElement.clientHeight || window.innerHeight;

  let topo = caixa.bottom + DISTANCIA_DO_BOTAO;
  const acima = caixa.top - DISTANCIA_DO_BOTAO - altura;
  if (topo + altura > janelaAltura - MARGEM_DA_JANELA && acima >= MARGEM_DA_JANELA) {
    topo = acima;
  }

  let esquerda = alinhamento === 'fim' ? caixa.right - largura : caixa.left;
  if (esquerda + largura > janelaLargura - MARGEM_DA_JANELA) {
    esquerda = janelaLargura - MARGEM_DA_JANELA - largura;
  }
  esquerda = Math.max(MARGEM_DA_JANELA, esquerda);

  elemento.style.top = `${Math.round(topo)}px`;
  elemento.style.left = `${Math.round(esquerda)}px`;
}
